__turbopack_context__.v({
  "className": "playfair_display_688a7810-module__E9SlBa__className",
  "variable": "playfair_display_688a7810-module__E9SlBa__variable",
});
